/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-stacked',
  templateUrl: './widget-layers-stacked.component.html',
  styleUrls: ['./widget-layers-stacked.component.css']
})
export class WidgetLayersStackedComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(stacked: boolean) {
    this.widgetLayers.layer(this.current).change({ stacked: stacked });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ stacked: stacked }, this.current);
  }

}
